import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { log } from 'console';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {

  constructor() { }

  public isInteger(evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9]+/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  //permite numeros negativos tambien
  public isNumber2(evt: KeyboardEvent): void {
    const key = evt.key;
    const input = (evt.target as HTMLInputElement).value;

    // Permitir teclas de control
    const allowedControlKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
    if (
      allowedControlKeys.includes(key) ||
      evt.ctrlKey || evt.metaKey
    ) {
      return;
    }

    const isNumber = /^[0-9]$/.test(key);
    const isMinus = key === "-";
    const isDot = key === ".";

    // Permitir "-" solo si es el primer carácter y aún no existe
    if (isMinus && input.length === 0) return;

    // Permitir "." solo si no hay otro punto decimal
    if (isDot && !input.includes(".")) return;

    // Bloquear todo lo que no sea válido
    if (!isNumber) {
      evt.preventDefault();
    }
  }

  public isNumber(evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    if (theEvent.keyCode != 13) {
      key = String.fromCharCode(key);
      var regexKex = /[0-9]|\./;
      if (!regexKex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  }

  public isAlphaNumeric(evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9a-zA-Z]+/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  public validField = (field: string, formRules: FormGroup): boolean => {
    return formRules.controls[field].errors && formRules.controls[field].touched;
  }

  //Funcion para pegar elementos en campo array al traer en el portapapeles varios datos desde un archivo de excel
  // Se recive evento, formulario en donde se requiere pegar los datos y el nombre del campo a afectar.
  public onPaste(event: ClipboardEvent, form: FormGroup, field: string) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    let items = pastedText.split(/\r?\n/).filter(item => item.trim() !== '');

    // Get current values
    let currentValues = form.get(field).value || [];

    // Combine current values with new items, removing duplicates
    let newValues = [...new Set([...currentValues, ...items])];

    // Update the form control
    form.get(field).setValue(newValues);

    // Prevent default paste behavior if needed, though for ng-select it might not be strictly necessary 
    // but good to avoid double pasting into the search input if focused
    event.preventDefault();

  }

}
